import QueryKeys from '@src/constants/queryKeys';
import useApiQuery from '@src/hooks/useApiQuery';
import { CalendarEvent } from '@src/types/Events';
import { useMemo } from 'react';

interface EventsRangeQueryBody {
  from: string | null;
  to: string | null;
}

interface UseGetEventsByRangeProps {
  body: EventsRangeQueryBody;
}

export default function useGetEventsByRange({
  body,
}: UseGetEventsByRangeProps) {
  const queryKey = useMemo(
    () => [QueryKeys.events, body.from ?? '', body.to ?? ''],
    [body.from, body.to],
  );

  return useApiQuery<CalendarEvent[]>({
    apiPath: '/events/get-by-range',
    queryKey,
    method: 'POST',
    useV2API: true,
    body,
    enabled: !!body.from && !!body.to,
  });
}
